import React, { HTMLAttributes, useEffect, useState } from 'react';
import { Link } from './Link';
import { useRouter } from 'next/router';

interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  pageTitle?: string;
  path?: string;
  listItemProps?: HTMLAttributes<HTMLElement>;
  linkProps?: HTMLAttributes<HTMLElement>;
}

export function Breadcrumbs({
  pageTitle,
  path,
  listItemProps,
  linkProps,
  ...props
}: BreadcrumbsProps) {
  const router = useRouter();
  const pathToUse = path ?? router.asPath;
  const pathSlugs = pathToUse.split('/').filter((slug) => slug !== '');
  const titles = pathSlugs.map(
    (slug) => `${slug[0].toUpperCase()}${slug.substring(1).replace(/-/g, ' ')}`
  );
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => setFirstRender(false), [firstRender]);

  if (pageTitle) {
    titles.splice(-1, 1, pageTitle);
  }

  return firstRender ? null : (
    <div data-testid="breadcrumbs" {...props}>
      <ul>
        {pathSlugs.map((slug, index) => (
          <li
            key={slug}
            className="inline before:mx-2 before:content-['>'] first:before:content-none"
            {...listItemProps}
          >
            <Link
              path={`/${pathSlugs.slice(0, index + 1).join('/')}`}
              title={titles[index]}
              isLast={index === pathSlugs.length - 1}
              {...linkProps}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
